(function () {
    'use strict';

    angular.module('gov.filters')
        .filter('govOffset', govOffset);

    govOffset.$inject = [];

    function govOffset() {
        return function (input, start) {
            start = _.parseInt(start, 10);
            return _.slice(input, start);
        }
    }
})();